import type {
  TooltipProps as ChakraTooltipProps,
  ThemingProps,
} from '@chakra-ui/react';
import { Tooltip as ChakraTooltip } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type TooltipProps = OmitChakraProps<
  ChakraTooltipProps,
  'motionProps' | keyof ThemingProps
>;

export const Tooltip = withChakraAs<TooltipProps, 'div'>((props) => {
  return <ChakraTooltip {...props} />;
});
